/* DeleteAction.js */

"use strict";

const {managerFor, refusalMessage} = require("../../../../lib/managedSchedules");

const TRIGGER_TYPE_NAME_MAX_LENGTH = 60;

class DeleteAction {
    constructor(logger, modalUserFeedback, gameEditor) {
        this._logger = logger;
        this._modalUserFeedback = modalUserFeedback;
        this._gameEditor = gameEditor;
        this.doTheThang = this.doTheThang.bind(this);
    }

    run() {
        const triggerType = this._gameEditor.getTriggerType();
        const triggerWorkType = triggerType.workType;
        const triggerTypeName = triggerType.name;
        const triggerTypeShortName =
            triggerTypeName.length > TRIGGER_TYPE_NAME_MAX_LENGTH
                ? triggerTypeName.substr(0, TRIGGER_TYPE_NAME_MAX_LENGTH) + "…"
                : triggerTypeName;

        const settingsBaseLink =
            window.location.origin +
            "#!/_app_/GameConsole/_s_/Settings/_sln_/Settings/_rd_/JTdCJTdE/_sr_/";
        const networkDiscoveryLink =
            window.location.origin +
            "/#!/_app_/GameConsole/_s_/GameCenter/_sln_/DeviceManager/_rd_/JTdCJTdE/_exp_/network_discovery";
        let errorMsg = "";

        if (triggerWorkType === "retrieveSupportData") {
            errorMsg =
                "Sorry! Cisco Support Data updates cannot be deleted. Go to <a class='sys-schedule-err' href='" +
                settingsBaseLink +
                "Organization/Integrations'>System Settings > Integrations</a> and disable the schedule.";
        }

        if (triggerWorkType === "runDataRetention") {
            errorMsg =
                "Sorry! The Data Retention schedule cannot be deleted. Go to <a class='sys-schedule-err' href='" +
                settingsBaseLink +
                "Organization/DataRetention'>System Settings > Data Retention</a> and disable the schedule.";
        }

        if (triggerWorkType === "networkDiscovery") {
            errorMsg =
                "Sorry! The Network Discovery schedule cannot be deleted. Go to <a class='sys-schedule-err' href='" +
                networkDiscoveryLink +
                "'>Device Manager > Network Discovery</a> and open the plan, click on Schedule, and disable it.";
        }

        // The owner would just recreate it. See lib/managedSchedules for why this is keyed on the
        // owner and not the work type.
        const manager = managerFor(triggerType);
        if (manager) {
            errorMsg = refusalMessage(manager, "deleted");
        }

        if (errorMsg) {
            return this._modalUserFeedback.displayError({
                errorMsg,
                errorCode: "",
                title: "Delete",
            });
        } else {
            return this._gameEditor
                .runQuickConfirmationActionWorkflow(
                    {
                        message:
                            'Are you sure you want to permanently delete "' +
                            triggerTypeShortName +
                            '"?',
                        title: "Delete",
                        confirmDetails: {
                            text: "Confirm",
                            type: "destructive",
                        },
                        rejectDetails: {
                            text: "Cancel",
                            type: "text",
                        },
                    },
                    this.doTheThang
                )
                .finally(() => {
                    if (this._gameEditor.currentWorkTrigRemoved) {
                        this._gameEditor.currentWorkTrigRemoved = false;
                        this._gameEditor.currentWorkTrigDeleteInProgress = false;
                        this._gameEditor.closeEditor(this._gameEditor.editorTabStateId, true);
                    }
                });
        }
    }

    doTheThang() {
        this._gameEditor.currentWorkTrigDeleteInProgress = true;
        return this._gameEditor
            .getTriggerType()
            .delete()
            .catch((err) => {
                this._logger.warn({error: err}, "DeleteAction.run() - Error");
                this._gameEditor.currentWorkTrigDeleteInProgress = false;
                if (err.errorCode === "EntityInteractionsError") {
                    return this._modalUserFeedback.displayError({
                        error: {errorMsg: "Cannot delete system schedule"},
                    });
                }
                if (err.errorCode === "NotAuthorized") {
                    return this._modalUserFeedback.displayError(err);
                }
                return Promise.reject(err);
            });
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = ["$teve.logger", "$teve.ui.userFeedback", "gameEditor.gameEditor"];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    title: "Delete Schedule",
    shown: true,
    order: 3,
};
